import React from "react";
import { MdQuiz } from "react-icons/md";
import Badge from "components/badge/Badge";
import Card from "components/card";
import { EmptyState } from "components/states";

const humanizeType = (type) =>
  String(type || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const QuestionsTab = ({ questions = [] }) => {
  if (questions.length === 0) {
    return (
      <Card padding="md">
        <EmptyState
          icon={MdQuiz}
          title="No Questions Yet"
          description="Edit the campaign to add survey questions."
        />
      </Card>
    );
  }

  return (
    <ol className="flex flex-col gap-4">
      {questions.map((question, index) => (
        <Card as="li" key={index} padding="md">
          <div className="mb-2 flex flex-wrap items-center gap-2">
            <Badge tone="neutral">Question {index + 1}</Badge>
            {question.type && <Badge tone="brand">{humanizeType(question.type)}</Badge>}
          </div>
          <h3 className="text-lg font-medium text-fg">
            {question.text}
            {question.required && (
              <>
                <span aria-hidden="true" className="ml-1 text-danger-fg">
                  *
                </span>
                <span className="sr-only"> (required)</span>
              </>
            )}
          </h3>

          {question.options && question.options.length > 0 && (
            <div className="mt-3">
              <p className="mb-2 text-sm text-fg-muted">Options:</p>
              <ul className="flex flex-wrap gap-2">
                {question.options.map((option, optIndex) => (
                  <li
                    key={optIndex}
                    className="rounded-full border border-line px-3 py-1 text-sm text-fg"
                  >
                    {option}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Card>
      ))}
    </ol>
  );
};

export default QuestionsTab;
